import { Suspense } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { AdminLayout } from '@components/layouts/admin.layout';

import { appConfig } from '@configs/app.config';

import { REDIRECT_URL_KEY } from '@constants/app.constant';

import { closeModal } from '@/features/slice/event/event-slice';
import { useUserVerify } from '@/hooks';

import { useAppDispatch, useAppSelector } from '../../features';
import PageLoader from '../ui/loader/page-loader';
import { PLoader } from '../ui/loader/pill-loader';
import Modal from '../ui/modal/modal';
import { useModalSwitch } from '../ui/modal/use-modal';

const { unAuthenticatedEntryPath } = appConfig;

export const ProtectedRoute = () => {
    const modalStatus = useAppSelector((state) => state.eventSlice.modalStatus);
    const dispatch = useAppDispatch();
    const renderModalContent = useModalSwitch();
    const location = useLocation();

    const { isLoading, isError, isSuccess } = useUserVerify();

    const onClickFormActionBtn = () => {
        dispatch(closeModal());
    };

    if (isLoading) {
        return (
            <div>
                <PageLoader />
            </div>
        );
    }

    if (isError) {
        return (
            <Navigate
                replace
                to={`${unAuthenticatedEntryPath}?${REDIRECT_URL_KEY}=${location.pathname}`}
            />
        );
    }

    if (isSuccess) {
        return (
            <AdminLayout>
                <div className="border-box p-2">
                    <Outlet />
                    <Modal
                        onClickDialog={onClickFormActionBtn}
                        open={modalStatus}
                    >
                        <Suspense fallback={<PLoader />}>
                            {renderModalContent}
                        </Suspense>
                    </Modal>
                </div>
            </AdminLayout>
        );
    }
};
